import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Se l'URL è già assoluto (http:// o https://), lo lascio così
    if (/^https?:\/\//i.test(req.url)) {
      // Fix: se la pagina è su HTTPS e la chiamata è HTTP → forzo HTTPS
      if (location.protocol === 'https:' && req.url.startsWith('http://')) {
        const httpsUrl = req.url.replace(/^http:\/\//i, 'https://');
        return next.handle(req.clone({ url: httpsUrl }));
      }
      return next.handle(req);
    }

    // Altrimenti aggiungo la baseUrl da environment
    const base = environment.apiUrl.replace(/\/+$/, ''); // tolgo eventuale "/" finale
    const path = req.url.replace(/^\/+/, '');            // tolgo eventuali "/" iniziali
    let fullUrl = `${base}/${path}`;

    // Se la pagina è su HTTPS ma l'URL costruito è HTTP (es. env non aggiornato) → forzo HTTPS
    if (location.protocol === 'https:' && fullUrl.startsWith('http://')) {
      fullUrl = fullUrl.replace(/^http:\/\//i, 'https://');
    }

    return next.handle(req.clone({ url: fullUrl }));
  }
}
